module.exports = __webpack_public_path__ + "static/media/ipicklogo.364d25fb.png";